import axios from "axios";
import { addMeetingLink, deleteMeetingLink, getMeetingLinks } from "./api";

/**
 * Re-export the getMeetingLinks function from api
 */
export { getMeetingLinks };

/**
 * Add a new link to a meeting
 * @param {string} meetingId - The ID of the meeting
 * @param {Object} linkData - Object containing link data
 * @returns {Promise<Object>} - The created link object
 */
export const addLink = async (meetingId, linkData) => {
  return addMeetingLink(meetingId, linkData);
};

/**
 * Update an existing link
 * @param {string} linkId - The ID of the link to update
 * @param {Object} linkData - Object containing updated link data
 * @returns {Promise<Object>} - The updated link object
 */
export const updateLink = async (linkId, linkData) => {
  try {
    // Since there's no direct updateLink function in the API,
    // we need to use axios directly
    const token = localStorage.getItem("token");
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    const API_URL =
      process.env.REACT_APP_API_URL || "http://localhost:5001/api";
    const response = await axios.put(`${API_URL}/links/${linkId}`, linkData, {
      headers,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating link:", error);
    throw error;
  }
};

/**
 * Delete a link
 * @param {string} linkId - The ID of the link to delete
 * @returns {Promise<Object>} - Response from the server
 */
export const deleteLink = async (linkId) => {
  return deleteMeetingLink(null, linkId);
};
